module.exports = __webpack_public_path__ + "img/c03_unitdruid_Normal_ua.fea7581b.webp";